export const NEW_GAME_CENTER_CONTAINER = {
  ACTION_TYPES: {
    fetchCompetition: 'fetchCompetitionHandler',
    breadcrumbsHandler: 'breadcrumbsHandler',
    fetchMetadata: 'fetchMetadata'
  },

  TAB_INDEX: {
    match: 0,
    lineups: 1,
    stats: 2,
    trends: 3,
    odds: 4,
    propositionBets: 5,
    h2h: 6
  }
};